module.exports = __webpack_public_path__ + "static/img/unit_click.91d9029d.svg";